// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"472":"d76a6372","489":"682572b6","970":"8d9976dc"}[chunkId] + ".css";
};